import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _has from 'lodash/has';
import _get from 'lodash/get';

import { AppContext } from 'commons-ui';
import { RoleDocument } from 'commons/models/marketingDashboard';

import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';
import { IRolesFormData } from '../../utils/constants';

const useClone = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestCreateRole } = useService();

	const data = hydrateFormData(_get(location, ['state', 'rowData']));
	if (_has(data, '_id')) {
		delete data._id;
	}
	const cloneRole = async (clonedData: RoleDocument) => {
		setShowLoader(true);

		try {
			await requestCreateRole(app.appName, clonedData);
			showAlert('Role Cloned successfully', { type: 'success' });
			setShowLoader(false);
			history.goBack();
		} catch (error: any) {
			showAlert(error.response?.data?.error ?? 'Error while cloning the role', { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (clonedData: IRolesFormData) => {
		cloneRole(dehydrateFormData(clonedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useClone;
